window.AddressSearch = {
    addressListItem: null,
    searchBox: null,
    searchInput: null,
    addressSearchResults: null,
    clearButton: null,

    init: function () {
        this.addressSearchResults = document.getElementById(
            "address-search-results"
        );
        this.addressListItem = document.querySelectorAll(".address-list-item");
        this.searchBox = document.getElementById("input-search-box");
        this.searchInput = this.searchBox.querySelector("input");
        this.clearButton = this.searchBox.querySelector(".clear-search");
        this.addEvents();
    },

    addEvents: function () {
        this.searchInput.addEventListener("input", () => {
            if (AddressSearch.searchInput.value) {
                this.fetchAddress(AddressSearch.searchInput.value);
                this.showAddressSearchResults();
                this.showCloseButton();
            } else {
                this.hideAddressSearchResults();
                this.hideCloseButton();
            }
        });

        this.addressListItem?.forEach((item) => {
            item.addEventListener("click", () => {
                const imageSrc = item
                    .querySelector("[data-logo]")
                    .getAttribute("src");
                const addressText = item.querySelector("[data-text]").innerText;
                this.updateSearchBox(imageSrc, addressText);
                this.hideAddressSearchResults();
            });
        });

        this.clearButton?.addEventListener("click", () => {
            this.clearSearchBox();
        });
    },

    updateSearchBox: function (imageSrc, addressText) {
        this.searchBox
            .querySelector("[data-logo]")
            .setAttribute("src", imageSrc);
        this.searchBox.querySelector("input").value = addressText;
    },

    clearSearchBox: function () {
        this.searchBox
            .querySelector("[data-logo]")
            .setAttribute("src", "/images/search-24.svg");
        this.searchBox.querySelector("input").value = "";
        this.hideAddressSearchResults();
        this.hideCloseButton();
    },

    showAddressSearchResults: function () {
        this.addressSearchResults.classList.remove("d-none");
        document.addEventListener("click", this.onOutsideClickAddress);
    },

    hideAddressSearchResults: function () {
        this.addressSearchResults.classList.add("d-none");
        document.removeEventListener("click", this.onOutsideClickAddress);
    },

    hideCloseButton: function () {
        this.clearButton.classList.add("d-none");
    },

    showCloseButton: function () {
        this.clearButton.classList.remove("d-none");
    },

    onOutsideClickAddress: function (e) {
        if (e.target === AddressSearch.searchInput) return;
        if (AddressSearch.addressSearchResults)
            AddressSearch.hideAddressSearchResults();
    },

    fetchAddress: function (value) {
        console.log("fetchAddress", value);
        let fetchAddressTimeout;
        let fetchAddressController;
        const mapToken = globalVar.mapbox_access_token;
        console.log("mapToken", mapToken);
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${value}.json?country=US&access_token=${mapToken}`;
        if (fetchAddressController) fetchAddressController.abort();
        clearTimeout(fetchAddressTimeout);

        var searchAddressResults = [];
        if (!value) {
            displayAddressSearchResult();
            return;
        }

        fetchAddressTimeout = setTimeout(() => {
            fetchAddressController = new AbortController();
            fetch(url, {
                signal: fetchAddressController.signal,
            })
                .then((res) => res.json())
                .then((data) => {
                    searchAddressResults = data.features;
                    this.displayAddressSearchResult(searchAddressResults);
                });
        }, 200);
    },
    displayAddressSearchResult: function (addressResults) {
        addressSearchResults.addEventListener;

        if (addressSearchResults) addressSearchResults.style.display = "block";

        const list = document.createElement("ul");
        list.className = "mb-0";

        addressResults?.forEach((result) => {
            let fullAddress = result.place_name;
            let streetAddress = fullAddress.substring(
                0,
                fullAddress.indexOf(",") + 1
            );
            let item = document.createElement("li");
            item.className = "address-list-item";

            let ancorItem = document.createElement("a");
            ancorItem.role = "button";

            let spanItem = document.createElement("span");
            spanItem.className = "address-ic position-absolute m-auto";

            let imageItem = document.createElement("img");
            imageItem.src = window.location.origin + "/images/search-24.svg";
            imageItem.setAttribute("data-logo", "");

            spanItem.appendChild(imageItem);
            ancorItem.appendChild(spanItem);

            let pItem = document.createElement("p");
            pItem.className = "text-xxl font-normal";
            pItem.innerText = streetAddress;
            pItem.setAttribute("data-text", "");

            let p_spanItem = document.createElement("span");
            p_spanItem.innerText = fullAddress.replace(streetAddress, "");
            pItem.appendChild(p_spanItem);

            ancorItem.appendChild(pItem);
            item.appendChild(ancorItem);

            item.addEventListener("click", () => {
                // let selectedAddressLng = item.getAttribute("data-lng");
                const imageSrc = item
                    .querySelector("[data-logo]")
                    .getAttribute("src");
                const addressText = item.querySelector("[data-text]").innerText;
                this.updateSearchBox(imageSrc, addressText);
                this.hideAddressSearchResults();
                this.showParcelPopupForSelectedAddress(result);
            });

            list.appendChild(item);
        });

        if (addressSearchResults)
            // Empty element and append new searched addresses
            this.addressSearchResults.innerHTML = "";
        this.addressSearchResults.appendChild(list);

        document.addEventListener("click", this.onOutsideClickAddress);
    },

    showParcelPopupForSelectedAddress: async function (addressResult) {
        let lat = addressResult.center[1];
        let lng = addressResult.center[0];

        lat = lat ? lat : 0;
        lng = lng ? lng : 0;

        map.flyTo({
            center: [lng, lat],
            zoom: 18,
            speed: 1,
            essential: true,
        });
    },
};
